import {
    BodyMediumRegular,
    BodySmallRegular,
    H2Emphasized,
    H5Emphasized,
    ReceiptTextIcon,
    XStack,
    YStack,
} from 'smoothie';

import { formatDollars } from '../../../common/utils/bankingUtils';
import type { IBill } from '../../types/Bill';
import { BillIcon, BillIconSize } from './BillIcons';

export enum BillsTotalView {
    DiscoveryReview = 'DiscoveryReview',
    OverviewHeader = 'OverviewHeader',
    HomeSummary = 'HomeSummary',
}

export const BillsTotal = ({
    bills,
    viewType,
    selectedBills,
    showSelectionCount,
}: {
    bills: IBill[];
    viewType: BillsTotalView;
    selectedBills?: IBill[];
    showSelectionCount?: boolean;
}) => {
    const billNumber = formatDollars(
        (selectedBills ?? bills).reduce(
            (acc, bill) => acc + (bill.monthlyAmount ?? 0),
            0,
        ),
        false,
    );

    const selectedCount = selectedBills?.length ?? 0;
    const totalCount = bills.length;

    switch (viewType) {
        case BillsTotalView.DiscoveryReview:
            return (
                <XStack
                    width="100%"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <YStack gap={4}>
                        <H5Emphasized>{billNumber}</H5Emphasized>
                        <BodyMediumRegular>Monthly average</BodyMediumRegular>
                    </YStack>
                    {showSelectionCount && (
                        <YStack gap={4} alignItems="flex-end">
                            <H5Emphasized>
                                {selectedCount} of {totalCount}
                            </H5Emphasized>
                            <BodyMediumRegular>Included</BodyMediumRegular>
                        </YStack>
                    )}
                </XStack>
            );
        case BillsTotalView.OverviewHeader:
            return (
                <YStack
                    width="100%"
                    gap={2}
                    justifyContent="center"
                    alignItems="center"
                    paddingTop={150}
                >
                    <BillIcon
                        size={BillIconSize.SMALL}
                        icon={ReceiptTextIcon}
                    />
                    <BodyMediumRegular color="$gray900" paddingTop={10}>
                        Monthly average bills
                    </BodyMediumRegular>
                    <H2Emphasized>{billNumber}</H2Emphasized>
                </YStack>
            );

        case BillsTotalView.HomeSummary:
        default:
            return (
                <XStack width="100%" justifyContent="space-between">
                    <YStack
                        width="85%"
                        gap={2}
                        justifyContent="center"
                        alignItems="flex-start"
                    >
                        <BodyMediumRegular color="$gray900">
                            Monthly average
                        </BodyMediumRegular>
                        <H2Emphasized>{billNumber}</H2Emphasized>
                        <BodySmallRegular color="$gray1000">
                            {`The average expected total of your ${bills.length > 1 ? `${bills.length.toString()} ` : ''}bills`}
                        </BodySmallRegular>
                    </YStack>
                    <BillIcon size={BillIconSize.XS} icon={ReceiptTextIcon} />
                </XStack>
            );
    }
};
